import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, BasicUserInfo } from '@services/auth.service';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class CallbackComponent implements OnInit {

  userInfo: BasicUserInfo;

  constructor(
    private readonly auth: AuthService,
    private readonly route: Router,
  ) { }

  ngOnInit(): void {
    this.checkAuth();
  }

  private async checkAuth(): Promise<void> {
  const isAuth = await this.auth.isAuthenticatedAsync();
  if (isAuth) {
    await this.getBasicUserInfo();
  } else {
    this.signIn();
  }
}

  private async getBasicUserInfo(): Promise<void> {
        this.userInfo = await this.auth.getBasicUserInfo();
        sessionStorage.setItem('cpf', this.userInfo.sub);
        sessionStorage.setItem('username', this.userInfo.displayName);
        this.route.navigate(['selecionar-empresa'])
  }

  private signIn(): void {
    this.auth.signIn();
  }
}
